import React from "react";
import "./skins.css";

function renderButtons(payload) {
  const buttons = payload?.buttons || [];
  if (!buttons.length) {
    return <div className="skin-empty-inline">등록된 버튼이 없습니다.</div>;
  }

  return (
    <div className="control-button-list">
      {buttons.map((button, index) => (
        <div className="control-button-item" key={`${button.label || "btn"}-${index}`}>
          <strong>{button.label || `버튼 ${index + 1}`}</strong>
          <span>{button.cmd?.cmd || "-"}</span>
        </div>
      ))}
    </div>
  );
}

export default function ControlProfileSkin({ controls = [], latestPayload, latestReceivedAt }) {
  return (
    <section className="skin-card control-profile-skin">
      <header className="skin-card__header">
        <h3>제어 설정</h3>
      </header>
      <div className="skin-card__body control-profile-list">
        {latestPayload ? (
          <div className="control-latest">
            <strong>최근 수신</strong>
            <span>{latestReceivedAt || "-"}</span>
          </div>
        ) : null}
        {!controls.length ? (
          <div className="skin-empty-inline">제어 설정이 없습니다.</div>
        ) : (
          controls.map((control, index) => (
            <article className="control-profile-item" key={`${control.sensor_key || "control"}-${index}`}>
              <div className="control-profile-item__top">
                <strong>{control.sensor_key || `제어 ${index + 1}`}</strong>
                <span>{control.control_type || "-"}</span>
              </div>
              {renderButtons(control.payload)}
            </article>
          ))
        )}
      </div>
    </section>
  );
}
